import { App, FormInstance } from "antd";
import { useFormSnapshot } from "./useFormSnapshot";
import { useLeaveConfirm } from "./useLeaveConfirm";

interface UseGuardedFormProps<T> {
    form: FormInstance;
    getSnapshot: () => T;
}

export const useGuardedForm = <T,>({ form, getSnapshot }: UseGuardedFormProps<T>) => {
    const { modal, message, notification } = App.useApp();

    const { isChange, setIsChange, handleCancel } = useLeaveConfirm({ modal });

    const { checkChange, commitSnapshot, resetSnapshot } = useFormSnapshot({
        form,
        getSnapshot,
        onStateChange: setIsChange,
    });

    return {
        isChange,
        checkChange,
        commitSnapshot,
        resetSnapshot,
        handleCancel,
        message,
        modal,
        notification
    };
};